<app-card [title]="'Income Information'">
  <form *ngIf="incomeForm" [formGroup]="incomeForm" class="income-form">
    <!-- (ngSubmit)="onSaveAndExit()" -->
    <div class="section" formGroupName="enrollmentEligibilityDTO">

      <!-- Total Gross Annual Household Income -->
      <div class="form-row">
        <div class="form-group full-width">
          <label for="income">Total Gross Annual Household Income*</label>
          <mat-form-field appearance="outline" class="full-width">
            <input matInput id="income" formControlName="income" placeholder="Total Gross Annual Household Income">
            <mat-error *ngIf="incomeForm.get('enrollmentEligibilityDTO.income')?.invalid">Income is required and cannot be more than 10digit</mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Number of Household Members -->
      <div class="form-row">
        <div class="form-group full-width">
          <label for="household">Number of Household Members (Including Patient) Who Depend on This Income*</label>
          <mat-form-field appearance="outline" class="full-width">
            <input matInput id="household" formControlName="household" placeholder="Number of Household Members">
            <mat-error *ngIf="incomeForm.get('enrollmentEligibilityDTO.household')?.invalid || 
            incomeForm.get('enrollmentEligibilityDTO.household')?.value === 0">
            Household is required and cannot be more than 2digit number
          </mat-error>
          
          </mat-form-field>
        </div>
      </div>




      <!-- Income Verification Method -->
      <h2>Income Verification Method*</h2>
      <p>{{incomeHeader}}</p>
      <mat-radio-group formControlName="incomeVerificationOption" class="radio-group">
        <mat-radio-button class="radio-option" value="1">
          <div class="radio-content">
            <span class="option-title">OPTION 1: </span>

          </div>
          <p>{{incomeOtpion1Text}}</p>
        </mat-radio-button>
        <mat-radio-button class="radio-option" value="2">
          <div class="radio-content">
            <span class="option-title">OPTION 2: </span>

          </div>
          <p>{{incomeOtpion2Text}}</p>
        </mat-radio-button>
      </mat-radio-group>



      <div *ngIf="incomeForm.get('enrollmentEligibilityDTO.incomeVerificationOption').value === '1'">
        <div>
          <p>{{verificationText}}</p>
        </div>
        <div class="signature-field">
          <mat-label class="signature-label">Sign Here*</mat-label>
          <!-- <canvas #signaturePad class="signature-pad" [class.disabled]="isSignatureAccepted">
          </canvas> -->
          <canvas #canvas class="signature-pad" width="500" height="100"
            [class.disabled]="isSignatureAccepted"></canvas>
        </div>

        <input type="hidden">
        <p class="error" *ngIf="incomeSignature?.invalid && incomeSignature?.touched">
          Signature is required
        </p>

        <!-- Accept Signature Button -->
        <div class="signature-button-container">
          <button class="button-Secondary" type="button" (click)="clearSignature()">Clear
            Signature</button>
          <button class="button-Primary" type="button" (click)="acceptSignature()" [disabled]="isSignatureAccepted">
            ACCEPT SIGNATURE
          </button>
        </div>
      </div>
      <div *ngIf="incomeForm.get('enrollmentEligibilityDTO.incomeVerificationOption').value === '2'">
        <div class="upload-container">
          <label for="fileUpload" class="upload-label">Upload Proof Of Income*</label>
          <div class="upload-box" [class.disabled]="selectedFiles.length > 0">
            <input
              id="fileUpload"
              type="file"
              (change)="onFilesSelected($event)"
              class="file-input"
              accept=".pdf,.png"
              [disabled]="selectedFiles.length > 0"
              (blur)="isIncomeDocumentTouched = true"
            />
        
            <div *ngIf="selectedFiles.length === 0" class="upload-placeholder">
              <div class="upload-icon-container">
                <img src="assets/images/uploadicon.svg" alt="Upload Icon" />
                <p>Drag or click to upload a document here</p>
                <small>(Supported file types: PDF, PNG)</small>
              </div>
            </div>
        
            <div class="uploaded-files" *ngIf="selectedFiles.length > 0">
              <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
                <div class="file-preview">
                  <img *ngIf="file.type === 'image'" [src]="file.preview" alt="{{ file.name }}" />
                  <mat-icon *ngIf="file.type !== 'image'" svgIcon="document-pdf"></mat-icon>
                </div>
                <p class="file-name">{{ file.name }}</p>
                <button mat-icon-button (click)="removeFile(i)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="error" *ngIf="incomeDocument?.invalid && isIncomeDocumentTouched && !incomeDocument?.errors?.['fileUpload'] && !incomeDocument?.errors?.['maxFileUploadSize']">
          Please upload proof of insurance
        </p>
        <p class="error" *ngIf="incomeDocument?.errors?.['fileUpload']">
          {{incomeDocument?.errors?.['fileUpload']}}
        </p>
        <p class="error" *ngIf="!incomeDocument?.errors?.['fileUpload'] && incomeDocument?.errors?.['maxFileUploadSize']">
          {{incomeDocument?.errors?.['maxFileUploadSize']}}
        </p>



      <div class="button-container">
        <button class="button-Secondary" [disabled]="!isValidToProceed" (click)="onSave(true)">
          Save and Exit
        </button>
        <button [disabled]="!isValidToProceed" class="button-Primary" (click)="onSave()">
          Next: {{nextStep?.enrollmentStepName}}
        </button>
      </div>
    </div>
  </form>
</app-card>

<loading-spinner *ngIf="isLoading"></loading-spinner>